import {observable, action, computed, observe, reaction, toJS} from 'mobx';
import {IQueryParams} from '../../types/IQueryParams';
import {DEFAULT_LANG} from '../constants';
import {customHistory} from "../../Root";
import {UrlBuilder} from "../../utils/urlBuilder";
import languagesStore from "../LanguagesStore/LanguagesStore";
import {Routes} from "../../routes";
import { analytics } from '../..';

class QueryParamsStore {
    @observable public queryParams:IQueryParams = {};

    constructor() {
        reaction(()=>this.queryParams, (change)=>{
            const url = UrlBuilder.Relative(location.pathname).searchParams(change).url;

            if(location.href !== url.href) {
                customHistory.push(url.href.substring(url.origin.length));
                analytics.setUserProperties(change)
            }
        })

        reaction(()=>this.queryParams.routeLang, (change)=>{
            languagesStore.setSelectedIETF(change);
        })
    }

    @action
    public setQueryParam = (params: IQueryParams) => {
        this.queryParams = params;
    };

    @action
    public updateQueryParam = (k: string, v: string) => {
        this.queryParams = {...this.queryParams, [k]: v};
    };

    @action
    public parseAndSetQuery = (query: string) => {
        const searchParams = new URLSearchParams(query);
        this.queryParams =  Array.from(searchParams.entries())
            .reduce((query, tuple)=>{
                const [key,value]=tuple;
                query[key]=value;
                return query;
            }, {});
    };

    @action
    public validateQueryParams = (buildingLang: string, availableLangs: string[]) => {
        if(!this.queryParams)
            return;

        if(!this.queryParams.routeLang) {
            this.updateQueryParam("routeLang", buildingLang || DEFAULT_LANG);
            return;
        }

        if(availableLangs.includes(this.queryParams.routeLang))
            return;

        this.updateQueryParam("routeLang", buildingLang);
    };

    @computed
    public get multiBuildingArray(){
        const params = this.queryParams;
        if(!params || !params.MultiBuilding) return null;
        return params.MultiBuilding.split(';');
    };

}

export const queryParamsStore = new QueryParamsStore();

export default queryParamsStore;
